import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { formatCurrencyInput, validateNumberInput, validatePasteInput } from '../../../helpers/number-input.helper';
import { TeamMember } from '../../../interfaces/team/member/member.interface';
import { CurrencyPipe } from '@angular/common';

@Component({
  selector: 'app-custommonthlyallowance',
  templateUrl: './custommonthlyallowance.component.html',
  styleUrls: ['./custommonthlyallowance.component.scss'],
  providers: [CurrencyPipe]
})
export class CustomMonthlyAllowanceComponent {
  @ViewChild('allowance') allowanceControl!: ElementRef<HTMLInputElement>;

  public form;
  public member: TeamMember;
  public amount: number;
  public validateNumber = validateNumberInput;
  public validatePaste = validatePasteInput;

  constructor(
    private formBuilder: UntypedFormBuilder,
    public dialogRef: MatDialogRef<CustomMonthlyAllowanceComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { member: TeamMember; teamAmount: number },
    private currencyPipe: CurrencyPipe,
  ) {
    this.member = data.member;
    this.amount = data.teamAmount;
    this.form = this.formBuilder.group({
      allowance: new UntypedFormControl(null, Validators.required),
    });
  }

  formatCurrency() {
    formatCurrencyInput(
      this.form.get('amount'),
      this.allowanceControl?.nativeElement ?? null,
      this.currencyPipe
    )
  }

  async setCustomMonthlyAllowance(): Promise<void> {
    this.dialogRef.close(this.form.get('allowance')?.value);
  }

  onDismiss(): void {
    this.dialogRef.close(null);
  }
}
